<app-banner [heading]="'CBSE MANDATORY DISCLOSURE'" [detail]="'ACHIEVING HIGH STANDARDS'"></app-banner>

<main id="main"><!-- ======= About Section ======= -->
    <section class="about" id="about">
    <div class="container">
    <div class="row">
    <div class="col-lg-12 col-md-6">
    <h3 class="heading">MANDATORY PUBLIC DISCLOSURE</h3>
    
    <p class="heading2">A: GENERAL INFORMATION</p>
    <!-- ======= Table Section ======= -->
    
    <table class="table table-hover">
        <thead>
            <tr>
                <th width="5%">S.NO.</th>
                <th width="70%">INFORMATION</th>
                <th scope="25%">DETAILS</th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <th scope="row">1</th>
                <td>NAME OF THE SCHOOL</td>
                <td>TAGORE GLOBAL SCHOOL, KURUKSHETRA</td>
            </tr>
            <tr>
                <th scope="row">2</th>
                <td>AFFILIATION NO</td>
                <td>531905</td>
            </tr>
            <tr>
                <th scope="row">3</th>
                <td colspan="">SCHOOL CODE</td>
                <td>41904</td>
            </tr>
            <tr>
                <th scope="row">4</th>
                <td colspan="">COMPLETE ADDRESS WITH PIN CODE</td>
                <td>SECTOR 29, GLOBAL CITY KURUKSHETRA-136118</td>
            </tr>
            <tr>
                <th scope="row">5</th>
                <td colspan="">PRINCIPAL'S NAME &amp; QUALIFICATION</td>
                <td>Dr. Jayeta Auddy<br>
                M.A.(Eng.), M.A( Eco.), B.Ed., D.Litt.</td>
            </tr>
            <tr>
                <th scope="row">6</th>
                <td colspan="">SCHOOL EMAIL ID</td>
                <td>tgskkr18@gmail.com</td>
            </tr>
            <tr>
                <th scope="row">7</th>
                <td colspan="">SCHOOL CONTACT DETAILS</td>
                <td>Reception :- 7082346751<br>
                Manager :- 9303350002<br>
                Principal :- 9050926751</td>
            </tr>
        </tbody>
    </table>
    <!-- ======= Table Section ======= --></div>
    
    <div class="col-lg-12 col-md-6">
    <p class="heading2">B: DOCUMENTS &amp; INFORMATION</p>
    <!-- ======= Table Section ======= -->
    
    <table class="table table-hover">
        <thead>
            <tr>
                <th width="5%">S.NO.</th>
                <th width="70%">DOCUMENTS/INFORMATION</th>
                <th width="25%">UPLOAD DOCUMENTS</th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <th scope="row">1</th>
                <td>COPY OF AFFILIATION / UPGRADATION LETTER</td>
                <td><a href="https://drive.google.com/file/d/1vd53WS4T7m0EzkSIU0LOhOTbt9lT4z1q/view?usp=sharing" target="_blank">VIEW</a></td>
            </tr>
            <tr>
                <th scope="row">2</th>
                <td>COPY OF SOCIETY REGISTRATION</td>
                <td><a href="https://drive.google.com/file/d/1WiTMpBpWDsie2Lhck-NfZ_YCzvwBWyPg/view?usp=sharing" target="_blank">VIEW</a></td>
            </tr>
            <tr>
                <th scope="row">3</th>
                <td colspan="">COPY OF NO OBJECTION CERTIFICATE</td>
                <td><a href="https://drive.google.com/file/d/1IeUfECBK880qAkoFiPOGN1Tq9yFAARld/view?usp=sharing" target="_blank">VIEW</a></td>
            </tr>
            <tr>
                <th scope="row">4</th>
                <td colspan="">COPY OF RECOGNITION CERTIFICATE</td>
                <td><a href="https://drive.google.com/file/d/1lENnYZa_KMCkY1V60kD4bSAJFy74rpHS/view?usp=sharing" target="_blank">VIEW</a></td>
            </tr>
            <tr>
                <th scope="row">5</th>
                <td colspan="">COPY OF BUILDING CERTIFICATE</td>
                <td><a href="https://drive.google.com/file/d/1Z5aJDLKqbQOmAP7oSxiLqN7QLbfiHmYf/view?usp=sharing" target="_blank">VIEW</a></td>
            </tr>
            <tr>
                <th scope="row">6</th>
                <td colspan="">COPY OF FIRE SAFETY CERTIFICATE</td>
                <td><a href="https://drive.google.com/file/d/1eGz1LFqBSWmw5AKJzEcOgJ0LZgUkMoss/view?usp=sharing" target="_blank">VIEW</a></td>
            </tr>
            <!--
                                <tr>
                                  <th scope="row">7</th>
                                  <td colspan="">COPY OF DEO CERTIFICATE </td>
                                   <td class=""><a href="assets/img/disclosure/b/8.pdf" target="_blank">VIEW</a></td>
                                </tr> -->
            <tr>
                <th scope="row">7</th>
                <td colspan="">COPY OF HEALTH &amp; SANITATION CERTIFICATE</td>
                <td><a href="https://drive.google.com/file/d/1Ve9nzDc95q871pNKfGvoZIAY_nV-5O1_/view?usp=sharing" target="_blank">VIEW</a></td>
            </tr>
            <tr>
                <th scope="row">8</th>
                <td colspan="">LAND DOCUMENT</td>
        <td><a href="https://drive.google.com/file/d/1XB6vMuEpy7Wsyd9T-dx2LeCptFljzCRC/view?usp=sharing" target="_blank">VIEW</a></td>
            
            </tr>
            <tr>
                <th scope="row">9</th>
                <td colspan="">PARENT TEACHER ASSOCIATION</td>
                <td><a href="https://drive.google.com/file/d/1f259DR0XvehwHi7vKBuMENpOOP-ZX-zF/view?usp=sharing" target="_blank">VIEW</a></td>
            </tr>
            <tr>
                <th scope="row">10</th>
                <td colspan="">SELF AFFIDAVIT OF SCHOOL</td>
                <td><a href="https://drive.google.com/file/d/1kU3faAcciI7vVihpIFWWYP8Ok34HqWNN/view?usp=sharing" target="_blank">VIEW</a></td>
            </tr>
            <tr>
                <th scope="row">11</th>
                <td colspan="">TRANSPORT SAFETY CERTIFICATE</td>
                <td><a href="https://drive.google.com/file/d/18adAICyVD37y1C3yrvW8WSUdbg-UTrGM/view?usp=sharing" target="_blank">VIEW</a></td>
            </tr>
            <tr>
                <th scope="row">12</th>
                <td colspan="">SCHOOL MANAGEMENT COMMITEE</td>
                <td><a href="https://drive.google.com/file/d/16fKpy-bvzDzmc6NfquSNEQ-Gh1A-IdHC/view?usp=sharing" target="_blank">VIEW</a></td>
            </tr>
            <tr>
                <th scope="row">13</th>
                <td colspan="">COPY OF DEO CERTIFICATE</td>
        <td><a href="https://drive.google.com/file/d/15SiEEDN_GOhd15V4xtkYRzwbAiBa300G/view?usp=sharing" target="_blank">VIEW</a></td>
            
            </tr>
            <tr>
                <th scope="row">14</th>
                <td colspan="">MANDATORY PUBLIC DISCLOSURE</td>
                <td><a href="https://drive.google.com/file/d/1_tpl6hkXhXBVKUvaK_nHGycYVSIeVILV/view?usp=sharing" target="_blank">VIEW</a></td>
            </tr>
        </tbody>
    </table>
    <!-- ======= Table Section ======= --></div>
    
    <div class="col-lg-12 col-md-6">
    <p class="heading2">C: RESULT &amp; ACADEMICS</p>
    <!-- ======= Table Section ======= -->
    
    <table class="table table-hover">
        <thead>
            <tr>
                <th width="5%">S.NO.</th>
                <th width="70%">DOCUMENTS/INFORMATION</th>
                <th width="25%">UPLOAD DOCUMENTS</th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <th scope="row">1</th>
                <td>FEE STRUCTURE</td>
                <td><a href="https://drive.google.com/file/d/10kanegFjMBr7EooC-FntavFAqayiG_Jc/view?usp=sharing">VIEW</a></td>
            </tr>
            <tr>
                <th scope="row">2</th>
                <td>ANNUAL ACADEMIC CALENDER</td>
                <td><a href="https://drive.google.com/file/d/1cFcbgzJLdTaBHLhLjg2H9ad2p1UgWemL/view?usp=sharing" target="_blank">VIEW</a></td>
            </tr>
            <!--<tr>
                                  <th scope="row">4</th>
                                  <td colspan="">LIST OF PARENTS TEACHERS MEMBERS</td>
                                    <td class=""><a href="assets/img/disclosure/c/1.pdf" target="_blank">VIEW</a></td>
                                </tr>
                                </tr>-->
            <tr>
                <th scope="row">3</th>
                <td>DETAILS OF TEACHERS' TRAINING</td>
                <td><a href="https://drive.google.com/file/d/1dIgZ-3UYU-8Ced0XVeCkdk_9OC3M0FUz/view?usp=sharing">VIEW</a></td>
            </tr>
            <tr>
                <th scope="row">4</th>
                <td>DETAILS OF SCHOOL CIRCULARS</td>
                <td><a href="https://drive.google.com/file/d/1Q2KU08H5sZYpE8mlIWA3YyrcHco4TR7j/view?usp=sharing">VIEW</a></td>
            </tr>
            <tr>
                <th scope="row">5</th>
                <td colspan="">SCHOOL VIDEO</td>
                <td><a href="https://www.youtube.com/watch?v=YjwcEIeK2wY" target="_blank">VIEW</a></td>
            </tr>
        </tbody>
    </table>
    <!-- ======= Table Section ======= --></div>
    
    <div class="col-lg-12 col-md-6">
    <p class="heading2">D: STAFF &amp; TEACHING</p>
    <!-- ======= Table Section ======= -->
    
    <table class="table table-hover">
        <thead>
            <tr>
                <th width="5%">S.NO.</th>
                <th>INFORMATION</th>
                <th width="25%">DETAILS</th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <th scope="row">1</th>
                <td>PRINCIPAL</td>
                <td>1</td>
            </tr>
            <tr>
                <th scope="row">2</th>
                <td>TOTAL NO OF TEACHERS</td>
                <td>33</td>
            </tr>
            <!--<tr>
                                  <th scope="row">3</th>
                                  <td colspan="">PGT</td>
                                   <td class="">8</td>
                                </tr>-->
            <tr>
                <th scope="row">3</th>
                <td colspan="">TGT</td>
                <td>5</td>
            </tr>
            <tr>
                <th scope="row">4</th>
                <td colspan="">PRT</td>
                <td>11</td>
            </tr>
            <tr>
                <th scope="row">5</th>
                <td colspan="">PGT</td>
                <td>10</td>
            </tr>
            <tr>
                <th scope="row">6</th>
                <td colspan="">PTI</td>
                <td>2</td>
            </tr>
            <tr>
                <th scope="row">7</th>
                <td colspan="">OTHER NON-TEACHING</td>
                <td>3</td>
            </tr>
            <tr>
                <th scope="row">8</th>
                <td colspan="">TEACHERS SECTION RATIO</td>
                <td>1:13</td>
            </tr>
            <tr>
                <th scope="row">9</th>
                <td colspan="">DETAILS OF SPECIAL EDUCATORS</td>
                <td>1</td>
            </tr>
            <tr>
                <th scope="row">10</th>
                <td colspan="">DETAILS OF WELLNESS AND COUNSELLOR</td>
                <td>1</td>
            </tr>
        </tbody>
    </table>
    <!-- ======= Table Section ======= --></div>
    </div>
    </div>
    </section>
    <!-- End About Section --></main>